import { Component, Input } from '@angular/core';
import CONFIGURATION from '../../../configurations/configuration';
@Component({
  selector: 'maintenance',
  templateUrl: './maintenance.component.html',
})
export class MaintenanceComponent {
  @Input() maintenanceMode: string;
  logoSrc: string;
  config = CONFIGURATION;
  mode: string;
  constructor() {
    this.logoSrc =
      this.config.countryCode === 'ID'
        ? '/assets/img/header/logo-mk.png'
        : '/assets/img/header/logo.png';
  }
}
